
import { useEffect, useState } from "react";
import { db } from "@/services/firebaseService";
import { getSortableOptions } from "@/services/sortableOptionService";
import { SortableOption } from "@/types/fieldsOptions";

export interface OfferingOption {
  value: string;
  label: string;
}

export const useOfferingOptions = () => {
  const [offeringOptions, setOfferingOptions] = useState<OfferingOption[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchOptions = async () => {
      try {
        const options = await getSortableOptions(db);
        // Filter for offering types and sort by sortOrder
        const formattedOptions = options
          .filter(opt => opt.type === "offering")
          .sort((a, b) => a.sortOrder - b.sortOrder)
          .map(opt => ({
            value: opt.id, // Use the document ID as the value
            label: opt.label // Use the label field for display
          }));
        
        setOfferingOptions(formattedOptions);
      } catch (error) {
        console.error("Error fetching offering options:", error);
        // Always set options to empty array in case of error to avoid undefined
        setOfferingOptions([]);
      } finally {
        setLoading(false);
      }
    };
    
    fetchOptions();
  }, []);

  return { offeringOptions, loading };
};
